/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EmailTemplateRestService, EmailTemplatesGridFilter } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';

import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayout, GridLayoutService } from '@gh/core-ui-grid';

import { Observable } from 'rxjs';

import { EmailTemplateDetails, EmailTemplateList } from './email-template.model';

@Injectable()
export class EmailTemplateTabBusinessService implements InitViewService {

  constructor(private restService: EmailTemplateRestService,
              private gridLayoutService: GridLayoutService) {
  }

  /**
   * @returns {{gridLayout: Observable<GridLayout>}}
   */
  initView(route: ActivatedRouteSnapshot): any {
    return {
      gridLayout: this.gridLayoutService.get('emailTemplates'),
    };
  }

  /**
   * Creates data source for list in Grid Component
   * @returns {SlicedDataSource<EmailTemplateList>}
   */
  findAllAsDataSource(filter: EmailTemplatesGridFilter): SlicedDataSource<EmailTemplateList> {
    return this.restService.findAllAsDataSource(filter);
  }

  /**
   * @param id
   * @returns {Observable<EmailTemplateListItemDto>}
   */
  get(id: ID): Observable<EmailTemplateDetails> {
    return this.restService.get(id);
  }

  checkLevel(template: EmailTemplateList): Observable<any> {
    return this.restService.checkLevel(template.id);
  }

  remove(template: EmailTemplateList): Observable<EmailTemplateList> {
    return this.restService.remove(template.id);
  }
}
